module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAkCAYAAAB8DZEQAAABQklEQVRIie3XvS8EYRDH8c+eE0SDU4hEIwoKjVwiUSo1Gj21TjSi1yjwN2i1GoXQKBQaclGSSCRCQuctjmKfu2zD42VJJPtLnsw8m9n57uyzm8wklWoNJrCGcbzg1feVoAWHWMRBUqnWhnH6g6QxjZWwFDar6MhxrYe8c2V0hs0RHnKsYAcLKJUyibtzBEBPsM+lnBNnlTSc34Q0VUAKSAEpIAWkgPxLyHPOuZ/+AtLMV85cXME82nIAPKIv+PUsZCCs3JWFbGA7En+JO3ShPxI7iWUkWcg+dj/xYKM4Ee+f6w1I9uD73gluaBD3OJZ2ncOR+GalX/lPptAe/DbMROKb48dXIFs4C/45Nj97Y1na5sNNJPZK+soaZxLTdbCtZenXAtO48PGUdSutYkh8CpgNtp5UqrUR7KFXvvNJp7T66TePLDce7QcGVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon-tel.png
// module id = xcTj
// module chunks = 1